import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "progressStep"]

  connect() {
    const step = new URLSearchParams(window.location.search).get("step")
    this.showStep(step || "event_details")
  }

  next() {
    const nextStepName = this.stepTargets[this.currentStepIndex + 1].dataset.stepName
    this.scrollToTop()
    this.showStep(nextStepName)
  }

  previous() {
    const previousStepName = this.stepTargets[this.currentStepIndex - 1].dataset.stepName
    this.scrollToTop()
    this.showStep(previousStepName)
  }

  showStep(stepName) {
    let stepIndex = 0
    this.stepTargets.forEach((target, index) => {
      const isCurrentStep = target.dataset.stepName === stepName
      target.style.display = isCurrentStep ? "block" : "none"
      if (isCurrentStep) {
        stepIndex = index
      }
    })

    this.progressStepTargets.forEach((target, index) => {
      if (index <= stepIndex) {
        target.classList.add("step-accent")
      } else {
        target.classList.remove("step-accent")
      }
    })

    this.updateURL(stepName)
    this.currentStepIndex = stepIndex
  }

  submit(event) {
    const form = this.element.querySelector("form")

    const bookingController = this.application.getControllerForElementAndIdentifier(
      this.element.querySelector("[data-controller*='booking']"),
      "booking"
    )

    if (bookingController && !bookingController.validateRequiredModifierGroups()) {
      event.preventDefault()

      // Show the packs step where modifier groups are located
      this.showStep("packs")
      return
    }

    if (!form.checkValidity()) {
      event.preventDefault() // Stop submission

      // Find the first invalid element
      const firstInvalidElement = form.querySelector(":invalid")
      if (!firstInvalidElement) return

      // Find the step that contains this element
      const stepElement = firstInvalidElement.closest("[data-booking-wizard-target='step']")
      if (stepElement) {
        // Switch to that step
        this.showStep(stepElement.dataset.stepName)

        // Ask the browser to show the validation messages
        form.reportValidity()
      }
    }
  }

  updateURL(stepName) {
    const url = new URL(window.location)
    url.searchParams.set("step", stepName)
    window.history.pushState({}, "", url)
  }

  get currentStepIndex() {
    return parseInt(this.data.get("currentStepIndex") || 0)
  }

  set currentStepIndex(index) {
    this.data.set("currentStepIndex", index)
  }

  scrollToTop() {
    document.body.scrollTop = 0 // For Safari
    document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
  }
}
